// extracted by mini-css-extract-plugin
module.exports = {"popup_form":"PopupForm_popup_form__1otcG","popup_form__header":"PopupForm_popup_form__header__NiZdZ","popup_form__error_message":"PopupForm_popup_form__error_message__fzygX"};